import s, { useState as I } from "react";
import { c as d, t as h, D as j } from "./app-a75c1d35.mjs";
import { L } from "./LinkPreviewCard-2daafeaa.mjs";
import { L as x } from "./Link-479ac100.mjs";
import { I as S } from "./Image-d6406817.mjs";
import { B as C } from "./Block-9b78bd10.mjs";
import "./CallToAction-d24a74ed.mjs";
import "./Icon-3122c134.mjs";
import "./LinkContext-0c83848a.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
function T(a, t) {
  if (a == null)
    return {};
  var e = A(a, t), n, r;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(a);
    for (r = 0; r < o.length; r++)
      n = o[r], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(a, n) && (e[n] = a[n]);
  }
  return e;
}
function A(a, t) {
  if (a == null)
    return {};
  var e = {}, n = Object.keys(a), r, o;
  for (o = 0; o < n.length; o++)
    r = n[o], !(t.indexOf(r) >= 0) && (e[r] = a[r]);
  return e;
}
function f() {
  return f = Object.assign || function(a) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (a[n] = e[n]);
    }
    return a;
  }, f.apply(this, arguments);
}
function w(a, t) {
  var e = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(a);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(a, r).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function p(a) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? w(Object(e), !0).forEach(function(n) {
      B(a, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(e)) : w(Object(e)).forEach(function(n) {
      Object.defineProperty(a, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return a;
}
function B(a, t, e) {
  return t in a ? Object.defineProperty(a, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : a[t] = e, a;
}
const G = {
  breakpointCols: void 0,
  // optional, number or object { default: number, [key: number]: number }
  className: void 0,
  // required, string
  columnClassName: void 0,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: void 0,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: void 0,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: void 0
}, b = 2;
class v extends s.Component {
  constructor(t) {
    super(t), this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this), this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this);
    let e;
    this.props.breakpointCols && this.props.breakpointCols.default ? e = this.props.breakpointCols.default : e = parseInt(this.props.breakpointCols) || b, this.state = {
      columnCount: e
    };
  }
  componentDidMount() {
    this.reCalculateColumnCount(), window && window.addEventListener("resize", this.reCalculateColumnCountDebounce);
  }
  componentDidUpdate() {
    this.reCalculateColumnCount();
  }
  componentWillUnmount() {
    window && window.removeEventListener("resize", this.reCalculateColumnCountDebounce);
  }
  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      this.reCalculateColumnCount();
      return;
    }
    window.cancelAnimationFrame && window.cancelAnimationFrame(this._lastRecalculateAnimationFrame), this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }
  reCalculateColumnCount() {
    const t = window && window.innerWidth || 1 / 0;
    let e = this.props.breakpointCols;
    typeof e != "object" && (e = {
      default: parseInt(e) || b
    });
    let n = 1 / 0, r = e.default || b;
    for (let o in e) {
      const i = parseInt(o);
      i > 0 && t <= i && i < n && (n = i, r = e[o]);
    }
    r = Math.max(1, parseInt(r) || 1), this.state.columnCount !== r && this.setState({
      columnCount: r
    });
  }
  itemsInColumns() {
    const t = this.state.columnCount, e = new Array(t), n = s.Children.toArray(this.props.children);
    for (let r = 0; r < n.length; r++) {
      const o = r % t;
      e[o] || (e[o] = []), e[o].push(n[r]);
    }
    return e;
  }
  renderColumns() {
    const {
      column: t,
      columnAttrs: e = {},
      columnClassName: n
    } = this.props, r = this.itemsInColumns(), o = `${100 / r.length}%`;
    let i = n;
    i && typeof i != "string" && (this.logDeprecated('The property "columnClassName" requires a string'), typeof i > "u" && (i = "my-masonry-grid_column"));
    const l = p(p(p({}, t), e), {}, {
      style: p(p({}, e.style), {}, {
        width: o
      }),
      className: i
    });
    return r.map((u, c) => /* @__PURE__ */ s.createElement("div", f({}, l, {
      key: c
    }), u));
  }
  logDeprecated(t) {
    console.error("[Masonry]", t);
  }
  render() {
    const t = this.props, {
      // ignored
      children: e,
      breakpointCols: n,
      columnClassName: r,
      columnAttrs: o,
      column: i,
      // used
      className: l
    } = t, u = T(t, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);
    let c = l;
    return typeof l != "string" && (this.logDeprecated('The property "className" requires a string'), typeof l > "u" && (c = "my-masonry-grid")), /* @__PURE__ */ s.createElement("div", f({}, u, {
      className: c
    }), this.renderColumns());
  }
}
v.defaultProps = G;
const M = "masonry-grid", H = "desktop", F = "masonry-grid__column", W = "masonry-grid__card-container", $ = "masonry-card__image-container", y = {
  masonryGrid: M,
  desktop: H,
  masonryGridColumn: F,
  masonryGridCardContainer: W,
  masonryCardImageContainer: $
}, U = "masonry-card", q = "masonry-card__title", R = "masonry-card__image-container", z = "masonry-card--pressed", K = "desktop", J = "masonry-card__save-button", Q = "masonry-card__save-button--hidden", V = "masonry-card__info", X = "masonry-card__date", Y = "masonry-card__date--hidden", Z = "masonry-card__title--hidden", ee = "masonry-card__description", te = "masonry-card__description--hidden", m = {
  masonryCard: U,
  masonryCardTitle: q,
  masonryCardImageContainer: R,
  masonryCardPressed: z,
  desktop: K,
  masonryCardSaveButton: J,
  masonryCardSaveButtonHidden: Q,
  masonryCardInfo: V,
  masonryCardDate: X,
  masonryCardDateHidden: Y,
  masonryCardTitleHidden: Z,
  masonryCardDescription: ee,
  masonryCardDescriptionHidden: te
}, ne = ({
  title: a,
  description: t,
  date: e,
  link: n,
  linkLocale: r,
  image: o
}) => {
  const [i, l] = I(!1);
  return /* @__PURE__ */ s.createElement(
    x,
    {
      className: d(
        m.masonryCard,
        i && m.masonryCardPressed
      ),
      href: n,
      locale: r,
      "data-testid": "masonry-card",
      disableLinkTextStyle: !0,
      onMouseDown: () => l(!0),
      onMouseUp: () => l(!1),
      onMouseLeave: () => l(!1)
    },
    /* @__PURE__ */ s.createElement(s.Fragment, null, /* @__PURE__ */ s.createElement(
      "div",
      {
        className: d(m.masonryCardImageContainer),
        "data-testid": "masonry-image"
      },
      o && /* @__PURE__ */ s.createElement(
        S,
        {
          credits: o.credits,
          src: o.src,
          width: o.width,
          height: o.height,
          altText: o.altText,
          imageLoader: o.imageLoader,
          styling: o.styling
        }
      )
    ), /* @__PURE__ */ s.createElement(
      "div",
      {
        className: d(m.masonryCardInfo),
        "data-testid": "masonry-content"
      },
      /* @__PURE__ */ s.createElement(
        "p",
        {
          className: d(
            m.masonryCardDate,
            h.textsLeadText,
            e === void 0 && m.masonryCardDateHidden
          )
        },
        `Date ${e}`
      ),
      /* @__PURE__ */ s.createElement("div", { className: m.masonryCardTitle }, /* @__PURE__ */ s.createElement("p", { className: h.textsComponentTitleBold }, a)),
      /* @__PURE__ */ s.createElement(
        "p",
        {
          className: d(
            m.masonryCardDescription,
            h.textsLeadText
          )
        },
        t
      )
    ))
  );
}, re = {
  default: 2,
  [j.md - 1]: 1
};
function ye(a) {
  const { variants: t } = a;
  return /* @__PURE__ */ s.createElement(
    C,
    {
      "data-testid": "masonry-block",
      topPadding: C.Padding.NONE,
      bottomPadding: C.Padding.LARGE
    },
    /* @__PURE__ */ s.createElement(C.Content, { "data-testid": "masonry-content" }, /* @__PURE__ */ s.createElement(
      v,
      {
        breakpointCols: re,
        className: d(y.masonryGrid),
        columnClassName: d(y.masonryGridColumn),
        "data-testid": "masonry"
      },
      t && t.length && t.map((e, n) => {
        const { masonry: r, linkPreview: o } = e;
        if (r && r.link)
          return /* @__PURE__ */ s.createElement(
            "div",
            {
              key: n,
              className: d(y.masonryGridCardContainer)
            },
            /* @__PURE__ */ s.createElement(ne, { ...r })
          );
        if (o) {
          const { card: i, hasImages: l, hasSaveButton: u } = o, {
            cardIntroText: c,
            cardTitle: _,
            imageProps: k,
            link: g,
            linkLabel: O,
            linkLocale: D,
            linkDescription: P,
            onSave: E,
            isSaved: N
          } = i;
          return /* @__PURE__ */ s.createElement(
            "div",
            {
              className: d(y.masonryGridCardContainer),
              key: i.link
            },
            /* @__PURE__ */ s.createElement(
              L,
              {
                key: g,
                cardIntroText: c,
                cardTitle: _,
                imageProps: k,
                link: g,
                linkDescription: P,
                linkLocale: D,
                hasImages: l,
                hasSaveButton: u,
                linkLabel: O,
                onSave: E,
                isSaved: N
              }
            )
          );
        }
      })
    ))
  );
}
export {
  ye as MasonryGrid
};
//# sourceMappingURL=Masonry.js.map
